import { connect } from 'react-redux';

import {
  GET_ROOM_IMAGES,

  RESET_ROOM_IMAGES,
} from 'store/room/actionTypes';

import ManagerPicture from './ManagerPicture';

const mapStateToProps = (state) => ({
  roomImageList: state.Room.roomImageList,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetRoomImages: (payload) => dispatch({
    type: GET_ROOM_IMAGES,
    payload,
  }),

  onResetRoomImageList: () => {
    dispatch({
      type: RESET_ROOM_IMAGES,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerPicture);
